module.exports = __webpack_public_path__ + "static/media/processometer-four.bc3c1028.png";